import { ProjectPermission, TenantPermission } from '../types/permissionTypes'

/**
 * Central permission definitions for the WebEDI application
 *
 * @description
 * Contains all permission constants for tenant and project level access control.
 * Permissions are organized in nested classes for better type safety and IDE support.
 *
 * Available permission groups:
 * - Tenant: Permissions for tenant-wide features
 * - Project: Permissions for project-specific features
 *
 * @example
 * ```typescript
 * // Check tenant permission
 * if (hasPermission(Permissions.Tenant.SupplierCockpit)) {
 *   // Access granted for supplier cockpit
 * }
 *
 * // Check project permission
 * if (hasPermission(Permissions.Project.Worklist)) {
 *   // Access granted for worklist
 * }
 * ```
 */

export class Permissions {
  public static readonly Tenant = class TenantPermissions {
    public static SupplierCockpit: TenantPermission =
      'webedi:suppliercockpit:access'
    public static CollectionSettings: TenantPermission =
      'webedi:collectionsettings:access'
    public static CollectionUserAdmin: TenantPermission =
      'webedi:collectionuseradmin:access'
    public static MasterData: TenantPermission = 'webedi:masterdata:access'
  }

  public static readonly Project = class ProjectPermissions {
    public static Worklist: ProjectPermission = 'webedi:worklist:access'
    public static History: ProjectPermission = 'webedi:history:access'
    public static ProjectUserAdmin: ProjectPermission =
      'webedi:projectuseradmin:access'
    public static ProjectSettings: ProjectPermission =
      'webedi:projectsettings:access'
    public static Trial: ProjectPermission = 'webedi:trial:access'
    public static DeliveryForecastHistory: ProjectPermission =
      'webedi:history_delfor:access'
    public static DeliveryForecastWorklist: ProjectPermission =
      'webedi:worklist_delfor:access'
    public static EInvoice: ProjectPermission = 'webedi:einvoice:access'
    public static EInvoiceHistory: ProjectPermission =
      'webedi:einvoicehistory:access'
  }
}
